import React from 'react'
import styled from '@emotion/styled'
import { COLORS } from 'parameters/index'
import { Topic } from 'services/ContentfulService/models/topics'
import { truncArray } from 'lib'
import { Box } from 'components/layout/primitives'
import { LinkButton } from 'ui/inputs/Button'

interface Props {
	topics: Topic[]
}

export const TopicsList: React.FC<React.PropsWithChildren<Props>> = ({ topics }): JSX.Element => {
	return (
		<Explore>
			<h3 style={{ marginBottom: '8px' }}>Discover Other Topics</h3>
			<p style={{ maxWidth: '350px' }}>
				Read articles to become better informed on personal finance, terminology, and more.
			</p>
			<ExploreTags>
				{truncArray(
					topics.filter(t => !t.hidden),
					12
				).map(topic => (
					<Box key={topic.name}>
						<LinkButton href={topic.relativePath} size="small">
							{topic.name}
						</LinkButton>
					</Box>
				))}
			</ExploreTags>
		</Explore>
	)
}

const Explore = styled.div`
	margin-top: 20px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	text-align: center;
	border-radius: 8px;
	box-shadow: 0 0 20px 0 rgba(69, 69, 69, 0.25);
	background-color: ${COLORS.WHITE};
	flex: 1;
	padding: 45px;
	height: 100%;
`

const ExploreTags = styled.div`
	display: flex;
	max-width: 800px;
	flex-wrap: wrap;
	justify-content: center;
	margin-top: 20px;
`
